import React from 'react'
import { Message } from '@arco-design/web-react'
import {
  IconSuccessTip,
  IconWarnTip,
  IconErrorTip,
} from '@arco-iconbox/react-aidb-v2'
import { IconWastePaper, IconSearch } from '@arco-iconbox/react-aidb-v2'
import Empty from './Empty'
import styles from './style/search-history-mod.module.less'

type BookLibrary = {
  category: 'BOOK_LIBRARY'
  page: number
  setPage: (number: number) => void
  setHistoryVisible: (boolean) => void
  removerHistory: (index: number) => void
  historyData: Array<{
    mainKeywordsValue: string
    classificationBook: {
      classificationBookValue: string
      classificationBookIdValue: string
    }
    keywordsBookValue: string
    keywordsOutlineValue: string
  }>
  setHistoryData: ([]) => void
  getSearchBack: (
    page: number,
    mainText: string,
    assortId: string,
    assortValue: string,
    bookKeywords: string,
    outlineKeywords: string,
    isAgainSearch: boolean,
  ) => void
}

type NewsLibrary = {
  category: 'NEW_LIBRARY'
  page: number
  setPage: (number: number) => void
  setHistoryVisible: (boolean) => void
  removerHistory: (index: number) => void
  historyData: Array<{
    station: {
      contentStationValue: string
      contentStationIdValue: string
    }
    newsKeywordsValue: string
    subtitleKeywordsValue: string
    timeSlot: string[]
  }>
  setHistoryData: ([]) => void
  getSearchBack: (
    page: number,
    stationValue: string,
    stationId: string,
    newsKeywords: string,
    subtitleKeywords: string,
    timeSlot: string[],
    isAgainSearch?: boolean,
  ) => void
}

type Props = BookLibrary | NewsLibrary

function SearchHistoryMod(props: Props) {
  const {
    category,
    page,
    setPage,
    setHistoryVisible,
    historyData,
    setHistoryData,
    removerHistory,
    getSearchBack,
  } = props

  return (
    <div className={styles['content']}>
      <div className={styles.title}>
        <p className={styles.titleText}>搜索记录</p>
        <div className="titleBut">
          <div
            className={styles.btn}
            onClick={() => {
              if (historyData.length) {
                if (category === 'BOOK_LIBRARY') {
                  window.localStorage.removeItem('bookLibraryHistoryList')
                } else if (category === 'NEW_LIBRARY') {
                  window.localStorage.removeItem('newsLibraryHistoryList')
                }
                setHistoryData([])
                Message.success({
                  icon: <IconSuccessTip useCurrentColor={false} />,
                  content: '清除成功！',
                })
              } else {
                Message.error({
                  icon: <IconErrorTip useCurrentColor={false} />,
                  content: '暂无数据！',
                })
              }
            }}>
            <div className={styles.icon}>
              <IconWastePaper useCurrentColor={true} />
            </div>
            <div className={styles.txt}>清除所有记录</div>
          </div>
        </div>
      </div>
      <div className={styles.list}>
        {historyData.length ? (
          category === 'BOOK_LIBRARY' ? (
            historyData.map((item, index) => {
              return (
                <div className={styles.item} key={index}>
                  <div className={styles.top}>
                    <div className={styles.row}>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>书籍分类：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.classificationBook.classificationBookValue
                              ? item.classificationBook.classificationBookValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.row} ${styles.w3}`}>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>正文关键字：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.mainKeywordsValue
                              ? item.mainKeywordsValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>书籍关键字：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.keywordsBookValue
                              ? item.keywordsBookValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>大纲关键字：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.keywordsOutlineValue
                              ? item.keywordsOutlineValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bot}>
                    <div
                      className={styles.btn}
                      onClick={() => {
                        setPage(0)
                        getSearchBack(
                          page,
                          item.mainKeywordsValue,
                          item.classificationBook.classificationBookIdValue,
                          item.classificationBook.classificationBookValue,
                          item.keywordsBookValue,
                          item.keywordsOutlineValue,
                          true,
                        )
                        setHistoryVisible(false)
                      }}>
                      <div className={styles.icon}>
                        <IconSearch useCurrentColor={true} />
                      </div>
                      <div className={styles.txt}>重新搜索</div>
                    </div>
                    <div
                      className={styles.btn}
                      onClick={() => removerHistory(index)}>
                      <div className={styles.icon}>
                        <IconWastePaper useCurrentColor={true} />
                      </div>
                      <div className={styles.txt}>删除记录</div>
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            historyData.map((item, index) => {
              return (
                <div className={styles.item} key={index}>
                  <div className={styles.top}>
                    <div className={styles.row}>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>新闻关键字：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.newsKeywordsValue
                              ? item.newsKeywordsValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.row} ${styles.w3}`}>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>（副标）关键字：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.subtitleKeywordsValue
                              ? item.subtitleKeywordsValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>内容源站：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.station.contentStationValue
                              ? item.station.contentStationValue
                              : '全部'}
                          </div>
                        </div>
                      </div>
                      <div className={styles.rowItem}>
                        <div className={styles.tit}>时间段：</div>
                        <div className={styles.tags}>
                          <div className={styles.tag}>
                            {item.timeSlot.length
                              ? `${item.timeSlot[0]} 到 ${item.timeSlot[1]}`
                              : '全部'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bot}>
                    <div
                      className={styles.btn}
                      onClick={() => {
                        setPage(0)
                        getSearchBack(
                          page,
                          item.station.contentStationValue,
                          item.station.contentStationIdValue,
                          item.newsKeywordsValue,
                          item.subtitleKeywordsValue,
                          item.timeSlot,
                          true,
                        )
                        setHistoryVisible(false)
                      }}>
                      <div className={styles.icon}>
                        <IconSearch useCurrentColor={true} />
                      </div>
                      <div className={styles.txt}>重新搜索</div>
                    </div>
                    <div
                      className={styles.btn}
                      onClick={() => removerHistory(index)}>
                      <div className={styles.icon}>
                        <IconWastePaper useCurrentColor={true} />
                      </div>
                      <div className={styles.txt}>删除记录</div>
                    </div>
                  </div>
                </div>
              )
            })
          )
        ) : (
          <Empty state={historyData.length ? true : false} title="暂无数据！" />
        )}
      </div>
    </div>
  )
}

export default SearchHistoryMod
